import React, { useEffect } from "react";

export default function WhyChooseKryzen() {
  useEffect(() => {
    const revealElements = document.querySelectorAll(".reveal");
    const onScroll = () => {
      revealElements.forEach((el) => {
        if (el.getBoundingClientRect().top < window.innerHeight - 80) {
          el.classList.add("active");
        }
      });
    };
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className=" py-5">
      {/* Only animation CSS */}
      <style>{`
        .reveal {
          opacity: 0;
          transform: translateY(30px);
          transition: all .8s cubic-bezier(0.23,1,0.32,1);
        }
        .reveal.active {
          opacity: 1;
          transform: translateY(0);
        }
        .delay-1 { transition-delay: .1s; }
        .delay-2 { transition-delay: .2s; }
        .delay-3 { transition-delay: .3s; }
        .delay-4 { transition-delay: .4s; }
        .delay-5 { transition-delay: .5s; }
        .delay-6 { transition-delay: .6s; }
      `}</style>

      <div className="container-xl">
        {/* Title */}
        <h2 className="text-center fw-bold display-5 mb-2 reveal">
          Why Choose Kryzen?
        </h2>

        {/* Subtitle */}
        <p
          className="text-secondary text-center fs-4 mx-auto mb-4 reveal delay-1"
          style={{ maxWidth: 850 }}
        >
          We are not just farm builders — we are innovators, educators, and
          long-term partners. Kryzen combines deep agricultural expertise with
          engineering, automation, and data-driven decision-making to build
          farms that deliver real, measurable results.
        </p>

        {/* Grid */}
        <div className="row row-deck g-4 mt-4">
          {whyData.map((item, index) => (
            <div key={index} className="col-sm-6 col-lg-4">
              <div
                className={`card bg-light border shadow-sm reveal delay-${
                  index + 1
                }`}
              >
                <div className="card-body">
                  <div className="fs-1 mb-3 text-success">{item.icon}</div>
                  <h3 className="fw-bold mb-2">{item.title}</h3>
                  <p className="text-secondary">{item.text}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// Data list
const whyData = [
  {
    icon: "🏆",
    title: "Proven Expertise",
    text: "Years of hands-on experience in hydroponics and climate-controlled agriculture with successful projects across India.",
  },
  {
    icon: "🤖",
    title: "Tech-Driven Farming",
    text: "SmartFarmOS, automation systems, and IoT monitoring solutions that boost consistency and yields.",
  },
  {
    icon: "📊",
    title: "Data-Backed Decisions",
    text: "Environmental analytics, crop data, and AI tools to optimize every part of your farm’s performance.",
  },
  {
    icon: "🛠️",
    title: "Complete Turnkey Solutions",
    text: "Design, supply, installation, training, and maintenance — everything for profitable modern farming.",
  },
  {
    icon: "🌱",
    title: "Sustainable by Design",
    text: "Up to 90% water savings, pesticide-free produce, and year-round farming efficiency.",
  },
  {
    icon: "🤝",
    title: "Long-Term Support",
    text: "Training, webinars, visits, customer support, and performance monitoring — we stay with you always.",
  },
];
